import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';

export default function RankingEvalSourcesScreen() {
    const { SourcesScreen } = useModule(rankingEvalModuleQuery);
    return <SourcesScreen />;
}
